// Module
var code = "<redux-decorator redux-provider=\"$.redux\" render=\"$.UserModal\" gettext-catalog=\"$.gettextCatalog\" pass-through=\"{\n    onModalClose: $.$close,\n    userId: $.userId,\n    userInfo: $.userInfo,\n    }\"></redux-decorator>\n";
// Exports
export default code;